import { findBellowByType } from '../../figma/DolEditor/helpers/nodeValue';
import { EXERCISE_GAP_FILL_WITH_HINT_QUESTION_OPTIONS } from '../../figma/BlogEditor/plugins/ExerciseGapFillWithHint/types';
import { getNodeText } from '../../figma/BlogEditor/plugins/shared-transforms';
import { useRootElement } from '../../slatePlugins/common/hocs/current-element.store';

export const useOptionListWithHint = () => {
  const rootElement = useRootElement();

  const dropDownOptions = {};
  const [dropdownNode] = findBellowByType(
    rootElement,
    EXERCISE_GAP_FILL_WITH_HINT_QUESTION_OPTIONS
  );
  dropdownNode?.children?.forEach((node) => {
    dropDownOptions[node.id] = {
      id: node.id,
      displayName: getNodeText(node),
    };
  });
  return {
    dropDownOptions: Object.keys(dropDownOptions)?.map((item) => {
      return {
        id: dropDownOptions[item]?.id,
        displayName: dropDownOptions[item]?.displayName,
      };
    }),
  };
};
